import { useState, useRef, useEffect } from 'react';
import styles from '../Daetong.module.css';

function PersonaCard({ persona, onClick }) {
    const [isVisible, setIsVisible] = useState(false);
    const [showVideo, setShowVideo] = useState(false);
    const videoRef = useRef(null);
    const cardRef = useRef(null);

    // IntersectionObserver로 화면 진입/이탈 감지
    useEffect(() => {
        const card = cardRef.current;
        if (!card) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                    } else {
                        setIsVisible(false);
                        setShowVideo(false);
                        if (videoRef.current) {
                            videoRef.current.pause();
                            videoRef.current.currentTime = 0;
                        }
                    }
                });
            },
            { threshold: 0.5 }
        );

        observer.observe(card);

        return () => {
            observer.disconnect();
        };
    }, []);

    // isVisible이 true가 되면 비디오 로드 후 재생
    useEffect(() => {
        if (isVisible && videoRef.current) {
            const video = videoRef.current;

            const handleLoadedData = () => {
                video.play().then(() => {
                    setShowVideo(true);
                }).catch(() => {});
            };

            video.addEventListener('loadeddata', handleLoadedData);
            video.load();

            return () => {
                video.removeEventListener('loadeddata', handleLoadedData);
            };
        }
    }, [isVisible]);

    // 비디오 재생 완료
    const handleVideoEnded = () => {
        setShowVideo(false);
    };

    return (
        <li
            ref={cardRef}
            className={`personaCard ${styles.personaCard} ${showVideo ? styles.personaCardActive : ''}`}
            onClick={onClick}
        >
            <div className={`personaCard_inner ${styles.personaCard_inner}`}>
                <div className={`personaMedia ${styles.personaMedia}`}>
                    <img
                        src={process.env.PUBLIC_URL + persona.IMAGE_PATH}
                        alt={persona.NAME}
                        className={`personaThumbnail ${styles.personaThumbnail} ${showVideo ? styles.hidden : ''}`}
                        loading="lazy"
                    />
                    <video
                        ref={videoRef}
                        src={isVisible ? process.env.PUBLIC_URL + persona.VIDEO_PATH : undefined}
                        className={`personaVideo ${styles.personaVideo} ${showVideo ? styles.visible : ''}`}
                        muted
                        playsInline
                        preload="none"
                        onEnded={handleVideoEnded}
                    />
                </div>
                <div className={`personaInfo ${styles.personaInfo}`}>
                    <h5 className={`personaName ${styles.personaName}`}>{persona.NAME}</h5>
                    {persona.TITLE && (
                        <p className={`personaTitle ${styles.personaTitle}`}>{persona.TITLE}</p>
                    )}
                    {persona.TAG && (
                        <span className={`personaTag ${styles.personaTag}`}>{persona.TAG}</span>
                    )}
                </div>
            </div>
        </li>
    );
}

export default PersonaCard;
